module.exports = __webpack_public_path__ + "img/gaodi.250ad6ef.jpg";